var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21146 15.8395H5.29842L12.4361 8.69678L11.3492 7.60985L4.21146 14.7525V15.8395ZM16.1032 7.49343L12.5367 3.96355L13.5638 2.93139C13.9298 2.56212 14.3753 2.37666 14.9003 2.37501C15.4254 2.37334 15.8726 2.55548 16.2418 2.92143L17.2341 3.91372C17.5801 4.2531 17.7551 4.65761 17.759 5.12726C17.7629 5.59693 17.5985 5.99812 17.2658 6.33084L16.1032 7.49343ZM14.8999 8.71762L6.03665 17.5808H2.46509V14.0143L11.3283 5.15105L14.8999 8.71762ZM11.8976 8.1533L11.3492 7.60985L12.4361 8.69678L11.8976 8.1533Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.1b17dc4dbe93e1d03a5fa1104ce38ff1.svg";
export { ForwardRef as ReactComponent };